import { useTranslation } from 'next-i18next';
import { Box, Container } from '@bridebook/ui';
import componentStyles from './as-seen-in.style';

const AsSeenIn = () => {
  const { t } = useTranslation('common');

  const styles = componentStyles();

  return (
    <Container pl={[6, 4, 4]} pr={[6, 4, 4]} pt={[10, 4, 4]} pb={[0, 4, 4]}>
      <Box style={styles.logosWrap}>
        <Box as="h4" mr={3} style={styles.title}>
          {t('asSeenIn.title')}
        </Box>
        <i className="logo-item nyt" />
        <i className="logo-item bbc" />
        <i className="logo-item mailonline" />
        <i className="logo-item vogue" />
        <i className="logo-item elle" />
        <i className="logo-item metro" />
        <i className="logo-item stylist" />
      </Box>
    </Container>
  );
};

export default AsSeenIn;
